import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const ParagraphSpacingUnit = z.enum(["Pixels", "Rem", "Percent"]);

export const ParagraphSpacingValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const ParagraphSpacingTokenData = tokenAliasOrValue(ParagraphSpacingValue);

export type ParagraphSpacingUnit = z.infer<typeof ParagraphSpacingUnit>;
export type ParagraphSpacingValue = z.infer<typeof ParagraphSpacingValue>;
export type ParagraphSpacingTokenData = z.infer<typeof ParagraphSpacingTokenData>;
